import React,{useEffect, useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import Header from '../Components/Header'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { ArrowBack, CalendarMonth, CopyAll, EditNote, Groups, Mail, Person3Outlined, Remove, Timelapse } from '@mui/icons-material';
import { add_report, add_reports } from '../Redux/reportsSlice'

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  minHeight:300,
  maxHeight:450,
  justifyContent:"center",
  alignItems:"center"
}),
);

const ItemBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
maxHeight:300,
minHeight:150
})
);

const CandidateTestPortal = ()=>{


	const theme = useTheme()
	const navigate = useNavigate()
	const [del, setDel] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [showModal, setShowModal] = React.useState(false);
	const [message, setMessage] = React.useState("");
    const [selected,setSelected] = useState(0)
    const [sending,setSending] = useState(false)
    const [loadding,setLoadding] = useState(false)
    const report = useSelector(state => state?.reports.report);
    const reports = useSelector(state => state?.reports.reports);
	const user = useSelector(state => state?.auth.user);
	const test = useSelector(state => state?.test.test);
	const tests = useSelector(state => state?.tests.tests);
	const dispatch = useDispatch()

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

  async function handleWrong(question){
    try {
        
        const send_data = {
            id:test?.id,
            email:report?.email,
            question:question
        }

        setLoadding(true)

        const handleSend = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}handle-wrong-test/`,send_data,{
                headers:{
                        "Content-Type":"application/json",
                        "Authorization":`Bear ${user?.accessToken}`
                    }
            }).catch(err=>{
                setLoadding(false)
                setMessage("connection error")
                setOpen(true)
                console.log(err)
            })

            // console.log(handleSend?.data)

        if (handleSend?.status == 200 && handleSend?.data.success == true) {

            const filterReports = reports?.filter(item=>item?.email !== report?.email)
            dispatch(add_reports([...filterReports,handleSend?.data?.report]))
            dispatch(add_report(handleSend?.data?.report))
            setMessage(handleSend?.data.message)
            setOpen(true)

        } else {
            setMessage(handleSend?.data.message)
            setOpen(true)
        }  
        setLoadding(false)  
    } catch (error) {
        console.log(error)
    }
}

async function handleCorrect(question){
try {

    setSending(true)
    const send_data = {
        id:test?.id,
        email:report?.email,
        question:question
    }

    const handleSend = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}handle-correct-test/`,send_data,{
            headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bear ${user?.accessToken}`
                }
        }).catch(err=>{
            console.log(err)
            setMessage("connection error")
            setOpen(true)
            setSending(false)
        })

        console.log(handleSend?.data)

    if (handleSend?.status == 200 && handleSend?.data.success) {
        
       const filterReports = reports?.filter(item=>item?.email !== report?.email)
        dispatch(add_reports([...filterReports,handleSend?.data?.report]))
        dispatch(add_report(handleSend?.data?.report))
        setMessage(handleSend?.data.message)
        setOpen(true)

    } else {
        setMessage(handleSend?.data.message)
        setOpen(true)
    } 
    setSending(false)   
} catch (error) {
    console.log(error)
}
}



	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography  sx={{fontSize:12,color:"gray"}}>Candidate Detail</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={()=>{
                        setOpen(false)
                    }} 
					open={open} 
					autoHideDuration={2000}
				/>
                <IconButton onClick={(e)=>{
                    e.preventDefault()
                    navigate("/testReport")
                }}>
                    <ArrowBack sx={{color:"gold"}} fontSize='small'/>
                </IconButton>
				<ContainerBox  sx={{backgroundColor:"#000",borderRadius:2,width:"100%"}}>
					<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="flex-start">
						<Typography mt={1}  ml={3} style={{fontSize:16,fontWeight:400,fontFamily:"dinofans"}}>
							Candidate Assessment Detail
						</Typography>
					</Box>
                    <Box width="100%" justifyContent="center" alignItems="center"  p={1} m={1}>
                        {report?.response?.test?.map((item,index)=>{
                            return(
                                <>
                                <Box key={index} width="100%" justifyContent="space-between" alignItems="center" ml={2} flexDirection="row"  display="flex" flexWrap="wrap">
                                    <Box width="80%" justifyContent="space-between" alignItems="center" flexDirection="row"  display="flex" flexWrap="wrap">
                                        <Box  width="90%">
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12,color:"gray"}}>
                                                Question
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff",whiteSpace:"pre-wrap"}}>
                                                {item?.question} 
                                            </Typography>
                                        </Box>
                                        <Box  width="90%">
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12,color:"gray"}}>
                                                Candidate's answer
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                                {item?.candidate_answer} 
                                            </Typography>
                                        </Box>
                                        <Box  width="40%">
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12,color:"gray"}}>
                                                Type of Question
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                                {item?.type} 
                                            </Typography>
                                        </Box>
                                        <Box  width="40%">
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12,color:"gray"}}>
                                                Score
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#ff0"}}>
                                                {item?.score} 
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box sx={{display:"flex",flexDirection:"row",width:"20%",justifyContent:"flex-start",alignItems:"center"}}>
                                        <IconButton disabled={sending || item?.isCorrect} onClick={async(e)=>{
                                            e?.preventDefault()
                                            setSelected(index)
                                            await handleCorrect(item?.question)
                                        }}>
                                            {
                                            ( sending && selected == index) ? <CircularProgress size={15} sx={{color:"#ff0"}}/>  : <img resizemode="contain" src={require("../assets/okey.jpg")} width={25} height={25} style={{borderRadius:10}}/> 
                                            }
                                        </IconButton>
                                        <IconButton disabled={loadding || !item?.isCorrect} onClick={async(e)=>{
                                            e.preventDefault()
                                            setSelected(index)
                                            await handleWrong(item?.question)
                                        }}>
                                        {
                                            (loadding && selected == index) ? <CircularProgress size={15} sx={{color:"#ff0"}}/>  : <img resizemode="contain" src={require("../assets/cross.jpg")} width={25} height={25} style={{borderRadius:10}}/>
                                        }
                                        </IconButton>
                                    </Box>
                                </Box>
                                <Divider sx={{mt:1,mb:1,width:"90%"}}/>
                                </>
                                )
                            })
                        }
                    </Box>
				</ContainerBox>
			</Container>
		</Box>
		)
}

export default CandidateTestPortal